import {type Post} from '../../types/posts';
import {type UserProfile} from '../../types/users';

import {collectUserIdsFromPost} from './collect_user_ids_from_post';

export function collectUserIdsFromPosts(posts: Post[]) {
    const userIdsSet = new Set<UserProfile['id']>();

    posts.forEach((post) => {
        const userIds = collectUserIdsFromPost(post);
        userIds.forEach((userId) => userIdsSet.add(userId));
    });

    return Array.from(userIdsSet);
}
